import { Box, IconButton, Tooltip } from "@mui/material";
import { Grid } from "@mui/material";

import Chackdocno from "../../CustomFunction/Docno/GetDocno";
import Topbar from "../../Components/Customtopbar/Topbar";
import CustomInput from "../../Components/CustomInput/CustomInput";
import CustomARInput from "../../Components/CustomARInput/CustomARInput";
import React, { useEffect } from "react";
import CustomDatePicker from "../../Components/CustomDatepicker/CustomDatePicker";
import CustomDocGroupInput from "../../Components/CustomDocgroupInput/customDocgroupinput";

import CustomUserInput from "../../Components/CustomUserInput/CustomUserInput";
import CustomDepartmentInput from "../../Components/CustomDepartment/CustomDepartmentInput";
import CustomSiteCodeInput from "../../Components/CustomSiteCode/CustomSiteCodeInput";
import ProductListInput from "../../Components/CustomProductInput/ProductListInput";

import { genpostURL, genpostURLTEST, genURL, genURLTEST } from "../../_getjson";
import axios from "axios";

import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
  GridRowModel,
} from "@mui/x-data-grid";

import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import DraggableDialog from "../../Components/CustomDialogs/DraggableDialog";
import ProductListData from "../../Components/ProductList/ProductListData";
import CustomUnitInput from "../../Components/CustomUnit/CustomUnitInput";

import ListData from "../../Components/CustomUnit/Components/ListData";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import CustomSnackbar from "../../Components/Snackbar/Snackbar";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import DateConvertByMoment from "../../CustomFunction/Date/DateconvertByMoment";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";

const styleMenu = {
  color: "black",
  cursor: "pointer",
  fontFamily: "Customfont !important",

  zIndex: 100,
};
const listmenu = [["-", "-"]];

export default function PSSTKJOBORDER() {
  const [selectionModel, setSelectionModel] = React.useState([]);

  const [state, setState] = React.useState({
    arCode: "",
    arName: "",
    remark: "",
    productionorderdate: Date.now(),
    docGroup: "",
    userCode: localStorage.getItem("Username"),
    startDate: Date.now(), //วันที่เริ่มทำงาน
    endDate: Date.now(), //วันที่กำหนดเสร็จงาน
    deliverDate: Date.now(), // วันที่ส่งมอบงาน
    departmentcode: "",
    sitecode: "",
    productName: "",
    productCode: "",
    departmentcode2: "",
    quantity: 0,
    unitCode: "",
    rowModesModel: {},
    openDialog: false,
    openDialogType: "",
    titleDialog: "เลือกสินค้า",
    tableIDClick: -1,
    rowData: [],
    docNo: "",
    openBackdrop: false,
    //snackbar
    colorSnackbar: "warning",
    iconSnackbar: CheckRoundedIcon,
    autoClose: 3600,
    messageSnackbar: "",
    openSnackbar: false,
    onLoad: false,
  });

  useEffect(() => {
    console.log("useEffectrowData");
    console.log(state.rowData);

    return () => {};
  }, [state.rowData]);

  const onClickTopBar = (e) => {
    console.log("onClickTopBar", e);
    switch (e) {
      case "save":
        saveData();
        break;
      case "new":
        location.reload();
        break;
      default:
        break;
    }
  };
  const saveData = () => {
    const parameter = new URLSearchParams();
    //ข้อมูลในตาราง
    let tableData = [];
    // เช็คข้อมูลในตาราง
    for (let i = 0; i < state.rowData.length && state.rowData[i].code; i++) {
      tableData.push({
        Productcode: state.rowData[i].code,
        Productname: state.rowData[i].name,
        Unitcode: state.rowData[i].unitCode,
        Quantity: state.rowData[i].qty,
        Comparativeprice: state.rowData[i].comparativePrice,
        Formula: state.rowData[i].formula,
        Remark: state.rowData[i].remark,
      });
    }
    parameter.append("tableData", JSON.stringify(tableData));
    let mainData = {
      CREATEUSER: state.userCode,
      DOCDATE: DateConvertByMoment(
        state.productionorderdate,
        "YYYY-MM-DD 00:00:00"
      ),
      DOCNO: state.docNo,
      REMARK: state.remark,
      ARCODE: state.arCode,
      ARNAME: state.arName,
      FGCODE: state.productCode,
      FGNAME: state.productName,
      UNITCODE: state.unitCode,
      FGQTY: state.quantity,
      REMAINQTY: state.quantity,
      REFQTY: "0.0",
      SOLINEID: 0,
      SOREFNO: "",
      WAREHOUSE: "",
      LOCATION: "",
      DEPARTMENT: state.departmentcode,
      PROJECT: "",
      ALLOCATECODE: "",
      SYSCREATE: DateConvertByMoment(
        state.productionorderdate,
        "YYYY-MM-DD HH:mm:ss"
      ),
      SYSUPDATE: DateConvertByMoment(
        state.productionorderdate,
        "YYYY-MM-DD HH:mm:ss"
      ),
      SITECODE: state.sitecode,
      STARTDATE: DateConvertByMoment(state.startDate, "YYYY-MM-DD 00:00:00"),
      FINISHDATE: DateConvertByMoment(state.endDate, "YYYY-MM-DD 00:00:00"),
      SHIPDATE: DateConvertByMoment(state.deliverDate, "YYYY-MM-DD 00:00:00"),
      USERCODE: "",
      DOCGROUP: state.docGroup,
      REFDOCNO1: "",
      REFDOCNO2: "",
      BILLREMARK1: "",
      BILLREMARK2: "",
      BILLREMARK3: "",
      BILLREMARK4: "",
      BILLREMARK5: "",
      CANCELDATE: "",
      CANCELUSER: 0,
      SYSDOCFLAG: "",
      SYSDOCREMARK: "",
      CLOSEREASON: "",
      OWNERCODE: state.userCode,
      CLOSEFLAG: 0,
    };
    parameter.append("mainData", JSON.stringify(mainData));
    parameter.forEach((element) => {
      console.log("element");
      console.log(element);
    });

    return;
    let url = genpostURL("csstkjoborder/InsertData?user=&provenance=web");
    axios.post(url, parameter).then((res) => {
      if (res.data.status === "success") {
        setState((prevState) => ({
          ...prevState,
          messageSnackbar: "บันทึกข้อมูลสำเร็จ",
          colorSnackbar: "success",
          iconSnackbar: CheckRoundedIcon,
          openSnackbar: true,
        }));
      }
    });
  };
  // ar input
  const setARData = (e) => {
    setState((prevState) => ({
      ...prevState,
      arCode: e.arCode,
    }));
  };
  const ARInputKeyDown = (e) => {
    console.log(e);
    // if (e === "Enter") {
    //     GetCustomer(state.arCode)
    // }
  };
  const rsDocGroup = (e) => {
    setState((prevState) => ({
      ...prevState,
      docGroup: e,
    }));
  };
  React.useEffect(() => {
    genDocNo();
    return () => {};
  }, [state.docGroup]);
  const genDocNo = async () => {
    // console.log("genDocNo")
    // await setState((prevState) => ({
    //     ...prevState,
    //     openBackdrop: true
    // }))
    if (state.docGroup === "") {
      setState((prevState) => ({
        ...prevState,
        docNo: "",
        // openBackdrop: false
      }));
    } else {
      await Chackdocno(state.docGroup, "CSSTKJOBORDER").then((result) => {
        console.log("genDocNo", state.docGroup, result);
        setState((prevState) => ({
          ...prevState,
          docNo: result,
          // openBackdrop: false
        }));
      });
    }
  };
  React.useEffect(() => {
    GetCustomer(state.arCode);
    return () => {};
  }, [state.arCode]);

  React.useEffect(() => {
    GetProductData(state.productCode);
    return () => {};
  }, [state.productCode]);
  const GetCustomer = async (val) => {
    console.log("GetCustomer");
    if (val !== "") {
      let url = "/CSAR/ARascode?arcode=" + val;
      await axios.get(genURL(url)).then(async (e) => {
        let customerName = "";
        for (let index = 0; index < e.data.length; index++) {
          customerName = e.data[index].NAMETH;
        }
        await setState((prevState) => ({
          ...prevState,
          arName: customerName,
        }));
      });
    }
  };
  const GetProductData = async (val) => {
    console.log("log" + val);
    let url = "/CSPRODUCT/Code?code=" + val;
    await axios.get(genURL(url)).then(async (e) => {
      let productNames = "";
      let stockUnit = "";

      for (let index = 0; index < e.data.length; index++) {
        productNames = e.data[index].NAMETH;
        stockUnit = e.data[index].STOCKUNIT;
      }
      await setState((prevState) => ({
        ...prevState,
        productName: productNames,
        unitCode: stockUnit,
      }));
      //   console.log(productNames);
    });
  };

  // table component
  React.useEffect(() => {
    setState({
      onload: true,
    });
    createRowFree();
    return () => {};
  }, []);

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    );
  }

  const handleAddClick = (id) => () => {
    console.log(id);
    // setRows(rows.filter((row) => row.id !== id));
    setState((prevState) => ({
      ...prevState,
      openDialog: true,
      openDialogType: "product",
      tableIDClick: id,
    }));
  };
  const handleAddUnitClick = (id) => () => {
    console.log(id);
    // setRows(rows.filter((row) => row.id !== id));
    setState((prevState) => ({
      ...prevState,
      openDialog: true,
      openDialogType: "unit",
      tableIDClick: id,
    }));
  };

  const getUnitName = async (value) => {
    let url = `CSUNIT/ByCode?code=` + value;
    let data = await axios.get(genURL(url)).then((e) => {
      return e.data[0].MYNAMETH;
    });
    return data;
  };
  const resultProduct = async (e) => {
    const productCode = state.rowData.findIndex(
      (data) => data.code === e[0]["code"]
    );

    let newDataRow, updatedData;
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === state.tableIDClick
    );
    //        console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
    if (productCode === -1) {
      updatedData = {
        ...state.rowData[currentDataIndex],
        code: e[0]["code"],
        name: e[0]["name"],
        qty: 1,
        unitCode: e[0]["unitCode"],
        unit: await getUnitName(e[0]["unitCode"]),
      };
      newDataRow = [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
    } else {
      updatedData = {
        ...state.rowData[productCode],
        qty: state.rowData[productCode]["qty"] + 1,
      };
      newDataRow = [
        ...state.rowData.slice(0, productCode),
        updatedData,
        ...state.rowData.slice(productCode + 1),
      ];
    }

    await setState((prevState) => ({
      ...prevState,
      openDialog: false,
      rowData: newDataRow,
    }));

    // await console.log("resultProduct", state.rowData)
  };

  const resultUnit = async (e) => {
    console.log("resultUnit", e);

    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === state.tableIDClick
    );
    //        console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
    // if (productCode === -1) {
    let updatedData = {
      ...state.rowData[currentDataIndex],
      unit: e[0]["name"],
      unitCode: e[0]["code"],
      qty: 1,
    };
    let newDataRow = [
      ...state.rowData.slice(0, currentDataIndex),
      updatedData,
      ...state.rowData.slice(currentDataIndex + 1),
    ];
    // } else {
    //     updatedData = { ...state.rowData[productCode], qty: state.rowData[productCode]["qty"] + 1 };
    //     newDataRow = [...state.rowData.slice(0, productCode), updatedData, ...state.rowData.slice(productCode + 1)]
    // }

    await setState((prevState) => ({
      ...prevState,
      openDialog: false,
      rowData: newDataRow,
    }));
  };

  const columns = [
    { field: "id", headerName: "id", width: 80, hide: true },
    {
      field: "code",
      headerName: "รหัสวัตถุดิบ",
      width: 200,
      editable: true,
    },
    {
      field: "productActions",
      type: "actions",
      headerName: "",
      width: 10,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<ManageSearchRoundedIcon />}
            label="ค้นหา"
            onClick={handleAddClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    {
      field: "name",
      headerName: "ชื่อวัตถุดิบ",
      width: 300,
      editable: false,
      // flex: 1
    },
    {
      field: "unit",
      headerName: "หน่วยนับ",
      width: 100,
      editable: false,
      flex: 0,
    },
    {
      field: "unitCode",
      headerName: "รหัสหน่วยนับ",
      width: 100,
      editable: false,
      flex: 0,
      hide: true,
    },
    {
      field: "unitActions",
      type: "actions",
      headerName: "",
      width: 10,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<ManageSearchRoundedIcon />}
            label="ค้นหา"
            onClick={handleAddUnitClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    {
      field: "formula",
      headerName: "สูตร",
      width: 150,
      editable: true,
      flex: 1,
    },
    {
      field: "qty",
      type: "number",
      headerName: "ปริมาณ",
      width: 100,
      editable: true,
      flex: 0,
    },

    {
      field: "remark",
      headerName: "หมายเหตุ",
      width: 300,
      editable: true,
      flex: 0,
    },
    {
      field: "comparativePrice",
      headerName: "ราคาเปรียบเทียบ",
      width: 200,
      editable: true,
      flex: 0,
    },
  ];
  const handleDelDataClick = async () => {
    const selectedIDs = new Set(selectionModel);
    // you can call an API to delete the selected IDs
    // and get the latest results after the deletion
    // then call setRows() to update the data locally here
    //  await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
    let x = state.rowData.filter((x) => !selectedIDs.has(x.id));
    await setState((prevState) => ({
      ...prevState,
      rowData: x,
    }));
  };
  // เพิ่มแถวในตาราง
  const handleAddRow = async () => {
    if (
      state.rowData.length > 0 &&
      typeof state.rowData.length !== "undefined"
    ) {
      let newDataRow;
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      newDataRow = await [
        ...state.rowData.slice(0, state.rowData.length),
        createRow(field, true),
      ];
      await setState((prevState) => ({ ...prevState, rowData: newDataRow }));
    } else {
      createRowFree(1);
    }
  };
  const CustomToolbar = () => {
    return (
      <>
        <GridToolbarContainer id={`GridToolbarContainerPSFG`}>
          <Grid
            spacing={2}
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ m: 0.1 }}
          >
            <Tooltip
              title="เพิ่มแถว"
              aria-label="addRows"
              style={{
                display: state.enableAddIcon === false ? "none" : "inherit",
              }}
              sx={{ styleMenu }}
            >
              <IconButton aria-label="addRows" onClick={(_) => handleAddRow()}>
                <PlaylistAddRoundedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title="ลบแถว"
              aria-label="delRows"
              style={{
                display:
                  selectionModel.length > 0
                    ? state.enableDelIcon === false
                      ? "none"
                      : "inherit"
                    : "none",
              }}
              sx={styleMenu}
            >
              <IconButton
                aria-label="delRows"
                onClick={(_) => handleDelDataClick()}
              >
                <DeleteOutlineRoundedIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </GridToolbarContainer>
      </>
    );
  };
  const createRowFree = (rowcount) => {
    let newRows =
      typeof rowcount === "undefined" || rowcount === "" ? 100 : rowcount;
    if (state.rowData.length <= 0) {
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      let data = [];
      //(prevRows) => [...prevRows, createRow(field, true)]
      for (let index = 0; index < newRows; index++) {
        data.push(createRow(field, true));
      }
      console.log("createRowFree", data);
      setState({
        rowData: data,
        onLoad: false,
      });
    }
  };

  let idCounter = 0;
  let rowNumber = 0;
  const createRow = (data, empty) => {
    // ถ้ามีข้อมูลใน rows state
    if (state.rowData.length > 0) {
      const ids = state.rowData.map((object) => {
        return object.id;
      });
      const max = Math.max(...ids);
      idCounter = max;

      const rowNumbers = state.rowData.map((object) => {
        return object.rowNumber;
      });
      const maxRowNumber = Math.max(...rowNumbers);
      rowNumber = maxRowNumber;
    }
    idCounter += 1;
    rowNumber += 1;
    let lastData;
    if (empty === true) {
      let newData = data.reduce((a, v) => ({ ...a, [v]: "" }), {});
      lastData = { ...newData, id: idCounter, rowNumber: rowNumber };
    }
    return lastData;
  };

  const handleCellEditCommit = async (params) => {
    console.log("handleCellEditCommit", params);
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === params.id
    );
    let newDataRow, updatedData;
    //กรอกราคาต้นทน
    if (params.field == "code") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        code: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    if (params.field == "formula") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        formula: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }

    if (params.field == "formula") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        formula: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    if (params.field == "qty") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        qty: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    if (params.field == "remark") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        remark: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    if (params.field == "comparativePrice") {
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        comparativePrice: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      //     // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }

    // เช็คสินค้า

    if (params.field == "code") {
      checkProduct(currentDataIndex, params.value);
    }
  };

  const handleRowUpdate = async (newRow) => {
    // Update the state with the modified row
    await setState((prevRows) =>
      prevRows.rowData.map((row) => (row.id === newRow.id ? newRow : row))
    );

    await console.log(state.rowData);
  };

  // check Product for table
  const checkProduct = async (currentDataIndex, val) => {
    let newDataRow, updatedData;

    let url = genURL("CSPRODUCT/Code?code=" + val);
    let res = await axios.get(url).then((e) => {
      return e;
    });

    console.log("checkProduct", res.data);

    if (res.data.length > 0) {
      //  console.log(res.data)
      //CODE:"00000-YSH73"
      // COSTTYPE: 0
      // CUSTORDER: "0.00"
      // DESCRIPTION: ""
      // GILOCATION: "8009001"
      // GIWAREHOUSE: "8009"
      // GRLOCATION: "8009001"
      // GRWAREHOUSE: "8009"
      // MAINGROUP: "02"
      // NAMEEN: ""
      // NAMESEARCH: ""
      // NAMETH: "ไฟท้ายชุด C100 สีแดง"
      // NETSTOCK: "3.00"
      // OLDCODE: ""
      // PICTURE1: ""
      // PICTURE2: ""
      // PICTURE3: ""
      // PICTURE4: ""
      // PRODUCTSET: 0
      // PURCHASEORDER: "0.00"
      // SALELASTPRICE: "360.00"
      // SALEORDER: "0.00"
      // SELFLAG: 0
      // STOCKQTY: "3.00"
      // STOCKQTYGI: "2.00ชุด"
      // STOCKQTYWH: "2.00"
      // STOCKTYPE: 0
      // STOCKUNIT: "07"
      // SUBGROUP1: "0201"
      // SUBGROUP2: "ZZ"
      // SUBGROUP3: "07"
      // SUBGROUP4: ""
      // SUBGROUP5: ""
      // TAXTYPE: 1
      // UNITNAME: "ชุด"

      updatedData = {
        ...state.rowData[currentDataIndex],
        code: res.data[0].CODE,
        name: res.data[0].NAMETH,
        qty: 1,
        unitCode: res.data[0].STOCKUNIT,
        unit: res.data[0].UNITNAME,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    } else {
      if (val !== "") {
        await setState((prevState) => ({
          ...prevState,
          messageSnackbar: "ไม่พบข้อมูล",
          colorSnackbar: "warning",
          iconSnackbar: ErrorOutlineRoundedIcon,
          openSnackbar: true,
        }));
      }

      updatedData = {
        ...state.rowData[currentDataIndex],
        code: "",
        code: "",
        name: "",
        qty: "",
        unitCode: "",
        unit: "",
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
  };
  //  end table component
  return (
    <Box>
      <Topbar
        listmenu={listmenu}
        title="บันทึกใบสั่งผลิตสินค้า"
        onClick={(e) => onClickTopBar(e)}
      />
      <Box className="PSAppfrom">
        <Grid container spacing={1} marginTop={1}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomARInput
              resData={(e) => setARData(e)}
              label={"รหัสลูกค้า"}
              keyDown={(e) => ARInputKeyDown(e)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomInput
              label={"ชื่อลูกค้า"}
              readonly={true}
              defaultValue={state.arName}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDatePicker
              title={"วันที่สั่งผลิต"}
              DateValue={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  productionorderdate: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDocGroupInput
              label={"กลุ่มข้อมูล"}
              resData={(e) => rsDocGroup(e)}
              tablename="CSSTKJOBORDER"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomInput
              label={"เลขที่ใบสั่งผลิต"}
              defaultValue={state.docNo}
              readonly={true}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomUserInput
              label={"ผู้รับผิดชอบ"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  userCode: e.userCode,
                }))
              }
              defaultValue={localStorage.getItem("Username")}
              multiselect={false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomInput
              label={"หมายเหตุ"}
              defaultValue={state.remark}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  remark: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDatePicker
              title={"วันที่เริ่มทำงาน"}
              DateValue={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  startDate: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDatePicker
              title={"วันที่กำหนดเสร็จงาน"}
              DateValue={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  endDate: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDatePicker
              title={"วันที่นัดส่งมอบ"}
              DateValue={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  deliverDate: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDepartmentInput
              label={"แผนก"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  departmentcode: e,
                }))
              }
              multiselect={false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomSiteCodeInput
              label={"สาขา"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  sitecode: e,
                }))
              }
              multiselect={false}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <ProductListInput
              label={"รหัสสินค้าสำเร็จรูป"}
              defaultValue={state.productCode}
              resultData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  productCode: e,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
            <CustomInput
              label={"ชื่อ/คำอธิบาย"}
              readonly={true}
              defaultValue={state.productName}
              resData={(e) => {
                console.log("resData" + e);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomDepartmentInput
              label={"แผนก"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  departmentcode2: e,
                }))
              }
              multiselect={false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomInput
              label={"ปริมาณ"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  quantity: e,
                }))
              }
              inputType={"number"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <CustomUnitInput
              label={"หน่วยนับ"}
              resData={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  unitCode: e,
                }))
              }
              defaultValue={state.unitCode}
              keyDown={(e) => console.log("keyDown")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {state.onLoad === false ? (
              <Box
                sx={{ height: "70vh" }}
                style={{ width: "100%" }}
                component="div"
              >
                <DataGrid
                  rows={state.rowData}
                  columns={columns}
                  sx={{
                    fontFamily: "Customfont !important",
                    cursor: "pointer",
                  }}
                  rowHeight={30}
                  hideFooter={true}
                  // onCellEditStart={handleCellEditStart}
                  components={{
                    Toolbar: CustomToolbar,
                    // LoadingOverlay: LinearProgress,
                  }}
                  checkboxSelection
                  disableSelectionOnClick={true}
                  selectionModel={selectionModel}
                  onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  // onRowEditStart={console.log("onRowEditStart")}
                  onCellEditCommit={handleCellEditCommit}
                  // onCellEditStop={handleOnCellEditStop}
                  // experimentalFeatures={{ newEditingApi: true }}
                  // processRowUpdate={handleRowUpdate}
                  // onProcessRowUpdateError={e => {
                  //     console.log(e);
                  // }}
                />
              </Box>
            ) : (
              "กำลังโหลด..."
            )}
          </Grid>
        </Grid>
      </Box>
      <DraggableDialog
        open={state.openDialog}
        title={state.titleDialog}
        closeDialog={(e) =>
          setState((prevState) => ({
            ...prevState,
            openDialog: false,
          }))
        }
      >
        {state.openDialogType === "product" ? (
          <ProductListData resultData={(e) => resultProduct(e)} />
        ) : state.openDialogType === "unit" ? (
          <ListData resultData={(e) => resultUnit(e)} />
        ) : null}
      </DraggableDialog>

      <CustomBackdrop
        open={state.openBackdrop}
        key={"CustomBackdropPSSTKJOBORDER"}
      />
      <CustomSnackbar
        place="br"
        color={state.colorSnackbar}
        icon={state.iconSnackbar}
        autoClose={state.autoClose}
        message={state.messageSnackbar}
        open={state.openSnackbar}
        closeNotification={() => {
          setState((prevState) => ({ ...prevState, openSnackbar: false }));
        }}
        close
      />
    </Box>
  );
}
